<template>
    <v-container>
        <div v-if="!itemGroupLoading">

            <v-row>
                <v-col>
                    <h4 class="text-h4">Item Group - {{ data.name }}</h4>
                    <p class="text-subtitle-1">Modify Item Group Information</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <ItemGroupForm
                        editMode
                        ref="form" 
                        v-model="data" 
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-btn color="primary" block @click="handleSave" :loading="loading">
                        <v-icon left>mdi-content-save</v-icon>
                        save
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                    <v-btn depressed block @click="handleCancel">
                        cancel
                    </v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>

                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-bind="alert" v-model="alert.value"/>
    </v-container>
</template>

<script>
import PAlert from './../../components/common/PAlert'
import ItemGroupForm from './../../components/warehouse/ItemGroupForm';
import { mapActions } from 'vuex';
export default {
    name: "MeasureUnitEditView",
    components: {
        ItemGroupForm,
        PAlert
    },
    data() {
        return {
            id: null,
            data: null,
            itemGroupLoading: false,
            alert: {
                title: "Alert",
                content: "Are you sure you want to save",
                value: false,
                callback: null
            },
            loading: false
        }
    },
    methods: {
        ...mapActions({
            snackbar: "ui/snackbar/show",
            findByID: "stock/itemGroup/findByID",
            update: "stock/itemGroup/update",
            remove: "stock/itemGroup/remove",
            pushItemGroup: "stock/itemGroup/search/push"
        }),
        getItemGroup() {
            this.itemGroupLoading = true
            this.findByID(this.id).then(response => {
                this.data = response.data
                if(this.data.parent) {
                    this.pushItemGroup(response.data.parent)
                    this.data.parent_id = this.data.parent.id;
                }
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({color: 'error', text: message })
            }).finally(() => {
                this.itemGroupLoading = false;
            })
        },
        handleSave() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to Save?", callback: this.save};
        },
        save(){
            this.loading = true 
            this.update(this.data).then(response => {
                this.$router.push({ name: "ItemGroupDisplay", params: { id: response.data.id } })
                this.snackbar({text: "Item Group Updated", color: "success"})
            }).catch( error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({color: 'error', text: message })
            }).finally(() => {
                this.loading = false
            })
        },
        handleDelete() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to Delete?", callback: this.removeItemGroup};
        },
        removeItemGroup() {
            this.loading = true
            this.remove(this.data).then(() => {
                this.snackbar({color: 'success', text: "Item Group Deleted" })
                this.$router.push({ name: "ItemGroupList" })
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({color: 'error', text: message })
            }).finally(() => {
                this.loading = false;
            })
        },
        navigateToList() {
            this.$router.push({ name: "ItemGroupList"})
        },
        handleCancel() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to Discard Changes?", callback: this.cancel};
        },
        cancel() {
            this.$router.back()
        }
    },
    mounted() {
        this.id = this.$route.params.id
        this.getItemGroup()
    },
    beforeRouteUpdate(to, from, next) {
        this.id = to.params.id;
        this.getItemGroup();
        next()
    }
}
</script>

<style>

</style>